import { seriesLoadScripts, loadLinks } from "../../utils/util";

const dependScripts = ["expendPlugins/libs/luckyexcel.umd.js"];

const dependLinks = [];

export function fileImport(data, isDemo, customDependScripts, customDependLinks) {
	// 加载 css
	loadLinks(customDependLinks || dependLinks);

	// 加载 js 依赖
	seriesLoadScripts(customDependScripts || dependScripts, null, () => {
		console.log("## 文件导入插件相关依赖加载完成！");
	});
}
